import { createAnimations } from "@tamagui/animations-css";
import { createTamagui, createTokens } from "tamagui";

import { colors } from "./colors";
import { fonts } from "./fonts";

const size = {
  0: 0,
  0.1: 1,
  0.2: 1.5,
  0.25: 2,
  0.3: 3,
  0.5: 4,
  0.6: 5,
  0.9: 7,
  1: 8,
  1.2: 10,
  1.3: 12,
  1.4: 12.5,
  1.5: 14,
  2: 16,
  2.3: 18,
  2.5: 20,
  2.8: 22,
  3: 24,
  3.3: 27,
  3.4: 28,
  3.5: 30,
  4: 32,
  4.1: 36,
  4.2: 38,
  5: 40,
  5.1: 41,
  5.2: 42,
  5.3: 44,
  5.8: 46,
  6: 48,
  6.5: 50,
  7: 52,
  7.3: 54,
  7.4: 56,
  7.5: 58,
  7.8: 60,
  8: 64,
  8.1: 66,
  8.5: 73,
  10: 80,
  10.5: 84,
  11: 88,
  12: 96,
  15: 120,
  true: 14,
};

const radius = {
  0.5: 2,
  1: 4,
  2: 8,
  4: 12,
  4.5: 14,
  5: 16,
  7: 20,
  8: 24,
  9: 32,
  10: 40,
};

const zIndex = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
};

export const tokens = createTokens({
  size,
  space: size,
  radius,
  zIndex,
  color: colors,
});

const config = createTamagui({
  animations: createAnimations({
    fast: "ease-in 150ms",
    medium: "ease-in 300ms",
    slow: "ease-in 450ms",
  }),

  fonts,
  tokens,

  themes: {
    light: {
      bg: tokens.color["bgpeach-500"],
      color: tokens.color["gray-primary-900"],
    },
  },

  media: {
    xs: { maxWidth: 660 },
    gtXs: { minWidth: 660 + 1 },
    sm: { maxWidth: 860 },
    gtSm: { minWidth: 860 + 1 },
    md: { maxWidth: 1020 },
    gtMd: { minWidth: 1020 + 1 },
    lg: { maxWidth: 1200 },
    gtLg: { minWidth: 1200 + 1 },

    short: { maxHeight: 760 },
    hoverNone: { hover: "none" },
    pointerCoarse: { pointer: "coarse" },
  },
});

type AppConfig = typeof config;

declare module "tamagui" {
  interface TamaguiCustomConfig extends AppConfig {}
}

export default config;
